// 📁 src/components/CaseList.jsx
import { useEffect, useState } from "react";
import { loadCase } from "../data/loadCase";
import CaseCard from "./CaseCard";
import { motion, AnimatePresence } from "framer-motion";
import { MonoButton, PaperDarkBG } from "../kits";

export default function CaseList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(3); // Anzahl sichtbar

  useEffect(() => {
    loadCase().then((data) => {
      setPosts(data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="p-6 max-w-6xl py-10 mx-auto">
      <PaperDarkBG className="rounded-sm sm:rounded-md">
        <h1 className="text-xs lg:text-sm font-mono mb-10 text-center text-white pt-2 pb-2 rounded-lg">
          Case Study <span className="text-orange-300">+</span>  Lösungen für Herausforderungen
        </h1>
      </PaperDarkBG>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 auto-rows-fr">
        <AnimatePresence>
          {loading
            ? Array.from({ length: 3 }).map((_, i) => (
                <motion.div
                  key={i}
                  className="bg-gray-100 h-64 rounded-lg animate-pulse flex items-center justify-center text-gray-500 text-sm"
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <span className="text-xs font-mono">Gleich geht`s los ...</span>
                </motion.div>
              ))
            : posts.slice(-visibleCount).map((post) => (
                <motion.div
                  key={post.slug}
                  className="h-full"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <CaseCard post={post} />
                </motion.div>
              ))}
        </AnimatePresence>
      </div>

      {/* Button nur anzeigen, wenn es noch mehr Posts gibt */}
      {!loading && posts.length > visibleCount && (
        <div className="mt-8 text-center">
          <MonoButton
            onClick={() => setVisibleCount((prev) => prev + 3)}
            className="px-4 py-2 text-xs font-mono bg-black 
             "
          >
            Mehr anzeigen
          </MonoButton>
        </div>
      )}
    </div>
  );
}
